import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:05</span> Introduction Started of Podcast and Michael</li>
                            <li><span>01:21</span> Michael’s Background and how did he decide to pursue this profession</li>
                            <li><span>02:59</span> IPredator and its consultation and inception</li>
                            <li><span>05:38</span> How does I predator come into this concept of helping Cyberbullying</li>
                            <li><span>07:25</span> Do we have enough knowledge about the past data of the internet</li>
                            <li><span>09:11</span> What’s Offline Distress and how do you explain it</li>
                            <li><span>11:46 </span> TekRevol Intro to Michael</li>
                            <li><span>14:34</span> How technology for change can help in this cause</li>
                            <li><span>18:08</span> Is a good idea to make an account</li>
                            <li><span>21:15</span> Idea about top 10 develop apps for games</li>
                            <li><span>23:24</span> How does being a cyber-psychologist and key factors to consider</li>
                            <li><span>28:19</span> Technology in Pandemic to connect with clients</li>
                            <li><span>29:17</span> How does it affect an individual</li>
                            <li><span>33:43</span> Online Safety thing and how to tackle the safety thing</li>
                            <li><span>37:40</span> Concept of IPredator</li>
                            <li><span>42:04</span> Tackling of the effect and Michael’s advice</li>
                            <li><span>45:25</span> Intelligence related to fraud</li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;